// Lib
import * as _ from 'lodash';
import { put, call, takeLatest } from "redux-saga/effects";

// Constants
import * as ACTIONS from "./actionTypes";

// Types
import { ActionGetDealerLMAPI, getDealerLMAPIError, getDealerLMAPISuccess, ActionPostDealerLMAPI, postDealerLMAPIError, postDealerLMAPISuccess } from './actions';
import { LMconfig } from './types';
import { LMConfigResponse, Validation } from './types';

import { createAPINetworkInstance } from '../../../../../common/api';
import { parseAPILMconfig, parseUILMconfig } from './utils';
import { parseLMConfigResquest } from './utils';

function* getDealerLMconfig(action: ActionGetDealerLMAPI) {
    try {
        const { listingId } = action
        const { data } = yield call(createAPINetworkInstance().get, `listing/${listingId}/data`);
        const lmconfig: LMconfig = parseAPILMconfig({ ...data });
        yield put(getDealerLMAPISuccess(lmconfig, data.defaults));
    } catch (err) {
        yield put(getDealerLMAPIError());
    }
}

function* postDealerLMconfig(action: ActionPostDealerLMAPI) {
    try {
        const { listingId, lmConfig, field } = action
        const apiLMRequest = parseLMConfigResquest(lmConfig,field);
        const data = {
            ...apiLMRequest
        }
        const response = yield call(createAPINetworkInstance().post, `listing/${listingId}/data`, data);
        const dataResponse: LMConfigResponse = response.data;
        const lmconfig: LMconfig = parseAPILMconfig({ ...response.data.data, iddealer: apiLMRequest.data.iddealer, idengine: apiLMRequest.data.idengine });
        const validation: Validation = dataResponse.validation;
        yield put(postDealerLMAPISuccess(field, lmconfig, validation));
    } catch (err) {
        yield put(postDealerLMAPIError());
    }
}

export default function* dealerLMConfigSagas() {
    yield takeLatest(ACTIONS.POST_DEALERLM_API_REQUEST, postDealerLMconfig);
    yield takeLatest(ACTIONS.GET_DEALERLM_API_REQUEST, getDealerLMconfig);
}